/* VÆLD — cart drawer.
   - Opens via [data-cart-open] or after a successful add-to-cart.
   - Closes via [data-cart-close], ESC, or backdrop click.
   - Add / change / remove items via Shopify's /cart/{add,change}.js,
     then refreshes content via the sections rendering API. */

(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var lastFocus = null;
  var isOpen = false;

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]:not(.cart-drawer__backdrop)');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 200);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // --- Open / close triggers --------------------------------------
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-cart-open]');
    if (openTrigger) {
      e.preventDefault();
      open();
      return;
    }
    var closeTrigger = e.target.closest('[data-cart-close]');
    if (closeTrigger && drawer.contains(closeTrigger)) {
      e.preventDefault();
      close();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isOpen) close();
    document.querySelectorAll('details.pcard__qa[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  // Close inline quick-add size pickers when clicking elsewhere
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('details.pcard__qa[open]');
    if (!open.length) return;
    open.forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // --- Refresh drawer (and cart count) ----------------------------
  function refresh() {
    var path = window.location.pathname || '/';
    return fetch(path + '?sections=cart-drawer,header', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;

        if (data['cart-drawer']) {
          var dDoc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var newContent = dDoc.querySelector('[data-cart-drawer-content]');
          var curContent = drawer.querySelector('[data-cart-drawer-content]');
          if (newContent && curContent) curContent.innerHTML = newContent.innerHTML;
        }

        if (data['header']) {
          var hDoc = new DOMParser().parseFromString(data['header'], 'text/html');
          var newCount = hDoc.querySelector('[data-cart-count]');
          var curCount = document.querySelector('[data-cart-count]');
          if (newCount && curCount) curCount.textContent = newCount.textContent;
        }
      });
  }

  // --- Add to cart (intercept all product forms) ------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add?"]');
    if (!form) return;

    e.preventDefault();
    // The activating button (may be a size button carrying name="id")
    var submit = e.submitter || form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = true;
      submit.classList.add('is-loading');
    }
    document.body.classList.add('cart-loading');

    var fd = new FormData(form);
    // Capture the chosen variant from the clicked submit button so the
    // inline quick-add size picker works across all browsers.
    if (e.submitter && e.submitter.name === 'id' && e.submitter.value) {
      fd.set('id', e.submitter.value);
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        // Close any open inline size pickers
        document.querySelectorAll('details.pcard__qa[open]').forEach(function (d) { d.removeAttribute('open'); });
        return refresh();
      })
      .then(function () { open(); })
      .catch(function (err) {
        var msg = (err && err.description) || 'Could not add to cart.';
        var notice = form.querySelector('[data-form-error]');
        if (notice) {
          notice.textContent = msg;
          notice.hidden = false;
        }
      })
      .finally(function () {
        if (submit) {
          submit.disabled = false;
          submit.classList.remove('is-loading');
        }
        document.body.classList.remove('cart-loading');
      });
  });

  // --- Quantity / remove (delegated, drawer DOM is replaced) ------
  drawer.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var key = item.dataset.key;
    var qty = parseInt(item.dataset.qty || '0', 10);

    if (e.target.closest('[data-cart-remove]')) {
      e.preventDefault();
      change(key, 0);
    } else if (e.target.closest('[data-qty-decrease]')) {
      e.preventDefault();
      change(key, Math.max(0, qty - 1));
    } else if (e.target.closest('[data-qty-increase]')) {
      e.preventDefault();
      change(key, qty + 1);
    }
  });

  function change(key, quantity) {
    document.body.classList.add('cart-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function () { return refresh(); })
      .finally(function () {
        document.body.classList.remove('cart-loading');
      });
  }
})();
